// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 15H4.19814C3.64087 14.8333 2 14 2 12C2 10 3.64087 9.16667 4.19814 9H5.43653M12 9L19.8019 9C20.3591 9.16667 22 10 22 12C22 14 20.3591 14.8333 19.8019 15H18.5635M9 12V4.19814C9.16667 3.64087 10 2 12 2C14 2 14.8333 3.64087 15 4.19814V5.43653M15 12V19.8019C14.8333 20.3591 14 22 12 22C10 22 9.16667 20.3591 9 19.8019V18.5635","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const System2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-2',
    ref,
    icon: element,
  },
));

System2Icon.displayName = 'System2Icon';

export default System2Icon;
